module.exports = __webpack_public_path__ + "static/modal_bg.51f23386.png";